<template>
  <b-form-group label="نمایش نمودار بر اساس" label-for="chartType">
    <b-form-select
      id="chartType"
      v-model="selectedType"
      :options="typesEnums"
    ></b-form-select>
  </b-form-group>
</template>
<script>
export default {
  emits: ["getChartType"],
  watch: {
    selectedType: {
      handler(val) {
        this.$emit("getChartType", this.selectedType);
      },
    },
  },
  data() {
    return {
      selectedType: null,
      typesEnums: [
        {
          text: "همه",
          value: null,
        },
        {
          text: "خرید درس",
          value: 2,
        },
        {
          text: "رزرو کلاس",
          value: 3,
        },
        {
          text: "پرداخت به استاد",
          value: 4,
        },
        {
          text: "خرید پلن های VIP",
          value: 7,
        },
      ],
    };
  },
  components: {
    BFormGroup,
    BFormSelect,
  },
};
import { BFormGroup, BFormSelect } from "bootstrap-vue";
</script>
